import { Link, useNavigation, redirect } from "react-router-dom";
import AuthForm from "../../../components/AuthForm";

import { API_BASE_URL } from "../../../config";

import "./LoginRegister.css";

const fields = [
  {
    label: "Your Name",
    type: "text",
    placeholder: "Full Name",
    name: "name",
  },
  {
    label: "Email",
    type: "email",
    placeholder: "example@email.com",
    name: "email",
  },
  {
    label: "Company Name",
    type: "text",
    placeholder: "Company Name",
    name: "company_name",
  },
  {
    label: "Website",
    type: "text",
    placeholder: "Company Name",
    name: "website",
  },
  {
    label: "Password",
    type: "password",
    placeholder: "",
    name: "password",
  },
  {
    label: "Repeat Password",
    type: "password",
    placeholder: "",
    name: "password_confirmation",
  },
];

export default function CompanyRegister() {
  const navigation = useNavigation();

  const isSubmitting = navigation.state === "submitting";

  return (
    <section id="login_register">
      <AuthForm
        method="POST"
        title="Register"
        fields={fields}
        buttonText={isSubmitting ? "Registering..." : "Register"}
        googleButtonText="Register via Google"
        roleName="company"
      >
        <div className="form-auth-message">
          <div className="form-auth-message__text">
            Already Have an account? <Link to="/login">Login Here</Link>
          </div>
        </div>
      </AuthForm>
    </section>
  );
}

export const companyRegisterAction = async ({ request }) => {
  const formData = await request.formData();

  const data = {
    name: formData.get("name"),
    email: formData.get("email"),
    company_name: formData.get("company_name"),
    website: formData.get("website"),
    password: formData.get("password"),
    password_confirmation: formData.get("password_confirmation"),
  };

  const response = await fetch(`${API_BASE_URL}/register/company`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  console.log("action result", result);

  if (result.success === false) {
    return {
      error: result.message || "Register failed. Please try again",
      errors: result.errors || [],
    };
  }

  localStorage.setItem("token", result.token);
  localStorage.setItem("approved", result.approved);
  localStorage.setItem("role", result.role);
  localStorage.setItem("id", result.id);
  localStorage.setItem("login_time", Date.now());

  return redirect("/company-approval");
};
